import { render, staticRenderFns } from "./VideoResponsive.vue?vue&type=template&id=a1abd06e&"
import script from "./VideoResponsive.vue?vue&type=script&lang=js&"
export * from "./VideoResponsive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports